import React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {Button} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

export const RFAsGrid = ({rows, loading, nominatedPlayer, onNominateButtonClick, isDraft}) => {

    const renderNominateButton = (params) => {
        const onClick = async () => {
            onNominateButtonClick(params.row)
        }
        return (
            <Button color="primary" onClick={onClick} style={{padding: 0}} disabled={!isDraft || !!nominatedPlayer}>Nominate</Button>
        )
    };

    const common = {sortable: false, disableColumnMenu: true};
    const rosterColumns = [
        {...common, width: 130, headerName: 'First Name', field: 'first_name'},
        {...common, width: 130, headerName: 'Last Name', field: 'last_name'},
        {...common, width: 60, headerName: 'Pos', field: 'pos', headerAlign: 'center', align: 'center'},
        {...common, width: 70, headerName: 'Team', field: 'team', headerAlign: 'center', align: 'center'},
        {...common, width: 90, headerName: 'Owner', field: 'manager_name', headerAlign: 'center', align: 'center'}
    ];

    const actionColumns = [
        {...common, width: 120, headerName: ' ', field: 'nominate', align: 'center', renderCell: renderNominateButton}
    ]

    let displayCols = [...rosterColumns, ...actionColumns];

    const calcWidth = (cols) => {
        return cols.reduce((t, c) => t + c.width, 0) + 2;
    };

    const determineRowClass = (params) => {
        if(nominatedPlayer && params.row.yahoo_id === nominatedPlayer.yahoo_id) return 'is-rfa';
        return params.row.display_order % 2 === 1 ? 'table-row-odd' : 'table-row-even';
    };

    return (
        <div style={{width: calcWidth(displayCols), marginTop: 20}}>
            {loading && <LinearProgress color="secondary"/>}
            <DataGrid columns={displayCols} rows={rows} hideFooter={true} columnHeaderHeight={30} rowHeight={23}
                      autoHeight getRowClassName={(params) => (determineRowClass(params))}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
};
